import { render, staticRenderFns } from "./namedComputer.vue?vue&type=template&id=16b87f5e&"
import script from "./namedComputer.vue?vue&type=script&lang=js&"
export * from "./namedComputer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports